import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import HomePage from './pages/homepage';
import ContactPage from './pages/contactpage';
import GalleryPage from './pages/gallerypage';
import AboutPage from './pages/aboutpage';
import FaqPage from './pages/faqpage';
import RoomPage from './pages/roompage';
import PackagesPage from './pages/packagespage';
import PlacesToVisitPage from './pages/placestovisitpage'
import CancellationPolicyPage from './pages/cancellationpolicypage';
import PaymentPage from './pages/paymentpage';
import VirtualTourPage from './pages/virtual-tour-page';
import LuxuryCottagePage from './pages/luxury-cottage-page';
import VillaPage from './pages/villapage';
import WoodenCottagePage from './pages/woodencottagepage';
import PrivacyPolicyPage from './pages/privacy-policy-page';
// import Accommodation from './components/accommodation';
import ExploreRoomsSection from './components/explore-rooms-section';


function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/gallery' element={<GalleryPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/faq' element={<FaqPage />} />
          <Route path='/rooms' element={<RoomPage />} />
          <Route path='/packages' element={<PackagesPage />} />
          <Route path='/explore-rooms' element={<ExploreRoomsSection/>}/>
          <Route path='/payment' element={<PaymentPage />} />
          <Route path='/places-to-visit' element={<PlacesToVisitPage />} />
          <Route path='/cancellation-policy' element={<CancellationPolicyPage />} />
          <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
          <Route path='/virtual-tour' element={<VirtualTourPage />} />
          <Route path="/rooms/luxury-cottage" element={<LuxuryCottagePage />} />
          <Route path="/rooms/villa" element={<VillaPage />} />
          <Route path="/rooms/wooden-cottage" element={<WoodenCottagePage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
